import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectUpdateFailedAction = {
	type: 'SUBJECT_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectUpdateFailedAction => ({
	type: 'SUBJECT_UPDATE_FAILED',
	payload,
});
